<template>
  <div class="container" id="visu-fancy-cerfa">
    <!--HEADER-->
    <b-row>
      <b-col cols="12" sm="12" md="2" lg="2" class="text-center">
        <img src="../img/logo-france.png" alt="République Française" />
        <div class="marginTop">Ministère chargé des transports</div>
      </b-col>
      <b-col
        v-if="typeCerfa == '14023'"
        cols="12"
        sm="12"
        md="8"
        lg="8"
        class="text-center"
      >
        <h1>
          Demande de permission ou d’autorisation de voirie, de permis de
          stationnement, ou d’autorisation d’entreprendre des travaux
        </h1>
        <div class="sous-title">Gestionnaires des réseaux routiers</div>
      </b-col>
      <b-col v-else cols="12" sm="12" md="8" lg="8" class="text-center">
        <h1>Demande d’arrêté de police de la circulation</h1>
        <div class="sous-title">Gestionnaires des réseaux routiers</div>
      </b-col>
      <b-col cols="12" sm="12" md="2" lg="2" class="text-center">
        <img src="../img/clicpermis/logo_cerfa.png" alt="Cerfa" />
        <div class="marginTop">N° {{ typeCerfa }}*01</div>
      </b-col>
    </b-row>

    <!-- LE DEMANDEUR -->
    <div
      class="section"
      v-if="
        cerfaSelected != 'undefined' && cerfaSelected.request.petitioner != null
      "
    >
      <h2>Le demandeur</h2>
      <b-row>
        <!-- TYPE DE DEMANDEUR -->
        <b-col cols="12" sm="12" md="12" lg="12">
          <div class="champ">
            <span
              :class="
                cerfaSelected.request.petitioner.nature == 'Particulier'
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Particulier</span>
            <span
              :class="
                cerfaSelected.request.petitioner.nature == 'Service public'
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Service public</span>
            <span
              :class="
                cerfaSelected.request.petitioner.nature ==
                'Maître d\'oeuvre ou conducteur d\'opération'
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal"
              >Maître d'oeuvre ou conducteur d'opération</span
            >
            <span
              :class="
                cerfaSelected.request.petitioner.nature == 'Entreprise'
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Entreprise</span>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="12" class="marginTop"></b-col>

        <!-- NOM -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Nom</label>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <div class="champ">
            {{ cerfaSelected.request.petitioner.lastName }}
          </div>
        </b-col>

        <!-- PRENOM -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Prénom</label>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <div class="champ">
            {{ cerfaSelected.request.petitioner.firstName }}
          </div>
        </b-col>

        <!-- DESIGNATION -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Dénomination</label>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <div class="champ">
            {{ cerfaSelected.request.petitioner.corporationName }}
          </div>
        </b-col>
        <!-- SIRET -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">N° SIRET</label>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <div class="champ">
            {{ cerfaSelected.request.petitioner.corporationSiret }}
          </div>
        </b-col>

        <!-- NOM, PRENOM -->
        <b-col cols="12" sm="12" md="4" lg="4">
          <label class="font-normal clearfix">Représenté par</label>
        </b-col>
        <b-col cols="12" sm="12" md="8" lg="8">
          <div class="champ">
            {{ cerfaSelected.request.petitioner.corporationAgent }}
          </div>
        </b-col>
        <!--ADRESSE SIEGE SOCIALE-->
        <b-col cols="12" sm="12" md="12" lg="12">
          <label class="clearfix">Adresse</label>
        </b-col>

        <!-- N° VOIE -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">N° voie</label>
        </b-col>
        <b-col cols="12" sm="12" md="2" lg="2">
          <div class="champ">
            {{ cerfaSelected.request.petitioner.addressNum }}
          </div>
        </b-col>

        <!-- EXTENSION -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Extension</label>
        </b-col>
        <b-col cols="12" sm="12" md="2" lg="2">
          <div class="champ">
            {{ cerfaSelected.request.petitioner.addressExt }}
          </div>
        </b-col>

        <!-- TYPE DE VOIE -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Type de voie</label>
        </b-col>
        <b-col cols="12" sm="12" md="2" lg="2">
          <div class="champ">
            {{ cerfaSelected.request.petitioner.addressType }}
          </div>
        </b-col>

        <!-- NOM VOIE -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Nom de voie</label>
        </b-col>
        <b-col cols="12" sm="12" md="10" lg="10">
          <div class="champ">
            {{ cerfaSelected.request.petitioner.addressName }}
          </div>
        </b-col>

        <!-- NOM VOIE -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Code Postal</label>
        </b-col>
        <b-col cols="12" sm="12" md="2" lg="2">
          <div class="champ">
            {{ cerfaSelected.request.petitioner.addressPostalCode }}
          </div>
        </b-col>

        <!-- LOCALITE -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Localité</label>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6">
          <div class="champ">
            {{ cerfaSelected.request.petitioner.addressCity }}
          </div>
        </b-col>

        <!-- TELEPHONE -->
        <b-col cols="12" sm="12" md="3" lg="2">
          <label class="font-normal clearfix">Téléphone</label>
        </b-col>
        <b-col cols="12" sm="12" md="3" lg="4">
          <div class="champ">{{ cerfaSelected.request.petitioner.phone }}</div>
        </b-col>

        <!-- INDICATIF
        <b-col cols="12" sm="12" md="3" lg="2">
          <label class=" font-normal clearfix "
            >indiquez l’indicatif pour le pays étranger</label
          >
        </b-col>
        <b-col cols="12" sm="12" md="3" lg="4">
          <div class="champ">
            {{ cerfaSelected.request.petitioner.phoneIndicative }}
          </div>
        </b-col> -->

        <b-col cols="12" sm="12" md="12" lg="12" class="nopadding"></b-col>

        <!-- EMAIL -->
        <!-- <b-col cols="12" sm="12" md="3" lg="2">
          <label class=" font-normal clearfix ">Adresse email</label>
        </b-col>
        <b-col cols="12" sm="12" md="9" lg="10">
          <div class="champ">{{ cerfaSelected.request.petitioner.email }}</div>
        </b-col> -->
      </b-row>
    </div>

    <!-- LE Beneficiaire -->
    <div
      class="section"
      v-if="
        cerfaSelected != 'undefined' &&
        cerfaSelected.request.beneficiary != null
      "
    >
      <h2>Le bénéficiaire</h2>
      <b-row>
        <!-- TYPE DE DEMANDEUR -->
        <b-col cols="12" sm="12" md="12" lg="12">
          <div class="champ">
            <span
              :class="
                cerfaSelected.request.beneficiary.nature == 'Particulier'
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Particulier</span>
            <span
              :class="
                cerfaSelected.request.beneficiary.nature == 'Service public'
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Service public</span>
            <span
              :class="
                cerfaSelected.request.beneficiary.nature ==
                'Maître d\'oeuvre ou conducteur d\'opération'
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal"
              >Maître d'oeuvre ou conducteur d'opération</span
            >
            <span
              :class="
                cerfaSelected.request.beneficiary.nature == 'Entreprise'
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Entreprise</span>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="12" class="marginTop"></b-col>
        <!-- NOM -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Nom</label>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <div class="champ">
            {{ cerfaSelected.request.beneficiary.lastName }}
          </div>
        </b-col>

        <!-- PRENOM -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Prénom</label>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <div class="champ">
            {{ cerfaSelected.request.beneficiary.firstName }}
          </div>
        </b-col>

        <!-- DESIGNATION -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Dénomination</label>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <div class="champ">
            {{ cerfaSelected.request.beneficiary.corporationName }}
          </div>
        </b-col>
        <!-- SIRET -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">N° SIRET</label>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <div class="champ">
            {{ cerfaSelected.request.beneficiary.corporationSiret }}
          </div>
        </b-col>

        <!-- NOM, PRENOM -->
        <b-col cols="12" sm="12" md="4" lg="4">
          <label class="font-normal clearfix">Représenté par</label>
        </b-col>
        <b-col cols="12" sm="12" md="8" lg="8">
          <div class="champ">
            {{ cerfaSelected.request.beneficiary.corporationAgent }}
          </div>
        </b-col>
        <!--ADRESSE SIEGE SOCIALE-->
        <b-col cols="12" sm="12" md="12" lg="12">
          <label class="clearfix">Adresse</label>
        </b-col>

        <!-- N° VOIE -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">N° voie</label>
        </b-col>
        <b-col cols="12" sm="12" md="2" lg="2">
          <div class="champ">
            {{ cerfaSelected.request.beneficiary.addressNum }}
          </div>
        </b-col>

        <!-- EXTENSION -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Extension</label>
        </b-col>
        <b-col cols="12" sm="12" md="2" lg="2">
          <div class="champ">
            {{ cerfaSelected.request.beneficiary.addressExt }}
          </div>
        </b-col>

        <!-- TYPE DE VOIE -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Type de voie</label>
        </b-col>
        <b-col cols="12" sm="12" md="2" lg="2">
          <div class="champ">
            {{ cerfaSelected.request.beneficiary.addressType }}
          </div>
        </b-col>

        <!-- NOM VOIE -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Nom de voie</label>
        </b-col>
        <b-col cols="12" sm="12" md="10" lg="10">
          <div class="champ">
            {{ cerfaSelected.request.beneficiary.addressName }}
          </div>
        </b-col>

        <!-- NOM VOIE -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Code Postal</label>
        </b-col>
        <b-col cols="12" sm="12" md="2" lg="2">
          <div class="champ">
            {{ cerfaSelected.request.beneficiary.addressPostalCode }}
          </div>
        </b-col>

        <!-- LOCALITE -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Localité</label>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6">
          <div class="champ">
            {{ cerfaSelected.request.beneficiary.addressCity }}
          </div>
        </b-col>

        <!-- TELEPHONE -->
        <b-col cols="12" sm="12" md="3" lg="2">
          <label class="font-normal clearfix">Téléphone</label>
        </b-col>
        <b-col cols="12" sm="12" md="3" lg="4">
          <div class="champ">{{ cerfaSelected.request.beneficiary.phone }}</div>
        </b-col>

        <!-- INDICATIF
        <b-col cols="12" sm="12" md="3" lg="2">
          <label class=" font-normal clearfix "
            >indiquez l’indicatif pour le pays étranger</label
          >
        </b-col>
        <b-col cols="12" sm="12" md="3" lg="4">
          <div class="champ">
            {{ cerfaSelected.request.beneficiary.phoneIndicative }}
          </div>
        </b-col> -->

        <b-col cols="12" sm="12" md="12" lg="12" class="nopadding"></b-col>

        <!-- EMAIL -->
        <!-- <b-col cols="12" sm="12" md="3" lg="2">
          <label class=" font-normal clearfix ">Adresse email</label>
        </b-col>
        <b-col cols="12" sm="12" md="9" lg="10">
          <div class="champ">{{ cerfaSelected.request.beneficiary.email }}</div>
        </b-col> -->
      </b-row>
    </div>

    <!-- LOCALISATION DU SITE -->
    <div
      class="section"
      v-if="cerfaSelected != 'undefined' && cerfaSelected.request != null"
    >
      <h2>Localisation du site concerné par la demande</h2>
      <b-row>
        <!-- Autoroute -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Autoroute n° :</label>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <div class="champ clearfix">
            <span v-if="cerfaSelected.request.wayType === 'Autoroute'">{{
              cerfaSelected.request.wayNum
            }}</span>
          </div>
        </b-col>
        <!-- Route nationale -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Route nationale n° :</label>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <div class="champ clearfix">
            <span v-if="cerfaSelected.request.wayType === 'Route nationale'">{{
              cerfaSelected.request.wayNum
            }}</span>
          </div>
        </b-col>
        <!-- Route départementale -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix">Route départementale n° :</label>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <div class="champ clearfix">
            <span
              v-if="cerfaSelected.request.wayType === 'Route départementale'"
              >{{ cerfaSelected.request.wayNum }}</span
            >
          </div>
        </b-col>
        <!--Voie communale -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix"
            >Voie communale / Voie intercommunale n° :</label
          >
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <div class="champ clearfix">
            <span
              v-if="
                cerfaSelected.request.wayType ===
                'Voie communale / Voie intercommunale'
              "
              >{{ cerfaSelected.request.wayNum }}</span
            >
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
          class="nopadding clearfix marginTop"
        ></b-col>

        <!--Hors agglomération -->
        <b-col cols="12" sm="12" md="2" lg="2">
          <label class="font-normal clearfix"></label>
        </b-col>
        <b-col cols="12" sm="12" md="10" lg="10">
          <div class="champ">
            <span
              :class="
                cerfaSelected.request.extraUrban == true
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Hors agglomération</span>
            <span
              :class="
                cerfaSelected.request.extraUrban == false
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">En agglomération</span>
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
          class="nopadding clearfix marginTop"
        ></b-col>

        <!-- POINT DE REPERE ROUTIER -->
        <b-col cols="12" sm="2" md="2" lg="2" class="nopadding">
          <label></label>
        </b-col>
        <b-col cols="12" sm="12" md="5" lg="5">
          <div class="champ">
            <span
              :class="
                (cerfaSelected.request.milestoneStart1 != null &&
                  cerfaSelected.request.milestoneStart1 != '') ||
                (cerfaSelected.request.milestoneStart2 != null &&
                  cerfaSelected.request.milestoneStart2 != '')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal"
              >Point de Repère (PR) routier de début d’application :</span
            >
          </div>
        </b-col>

        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.request.milestoneStart1 }}</div>
        </b-col>
        <b-col lg="1" md="1" sm="12" cols="12">
          <div class="text-center font-normal">+</div>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.request.milestoneStart2 }}</div>
        </b-col>
        <!-- POINT DE REPERE ROUTIER FIN -->
        <b-col
          lg="12"
          md="12"
          sm="12"
          cols="12"
          class="no-padding marginTop"
        ></b-col>
        <b-col lg="2" md="2" sm="12" cols="12" class="no-padding">
          <label></label>
        </b-col>
        <b-col lg="5" md="5" sm="12" cols="12">
          <div class="champ">
            <span
              :class="
                (cerfaSelected.request.milestoneEnd1 != null &&
                  cerfaSelected.request.milestoneEnd1 != '') ||
                (cerfaSelected.request.milestoneEnd2 != null &&
                  cerfaSelected.request.milestoneEnd2 != '')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal"
              >Point de Repère (PR) routier de fin d’application :</span
            >
          </div>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.request.milestoneEnd1 }}</div>
        </b-col>
        <b-col lg="1" md="1" sm="12" cols="12">
          <div class="text-center font-normal">+</div>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.request.milestoneEnd2 }}</div>
        </b-col>
        <b-col lg="12" md="12" sm="12" cols="12">
          <b>Nota :</b> Pour connaître la délimitation du domaine public routier
          au droit d’une propriété riveraine, il faut déposer, auprès du
          gestionnaire de la route concernée et selon les modalités qu’il aura
          fixées, en complément, une demande d’alignement individuel.
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="marginTop">
          <b>Adresse</b>
        </b-col>
        <!-- N° VOIE -->
        <b-col lg="2" md="2" sm="12" cols="12">
          <label class="font-normal clearfix">N° voie</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.request.addressNum }}</div>
        </b-col>
        <!-- EXTENSION -->
        <b-col lg="2" md="2" sm="12" cols="12">
          <label class="font-normal">Extension</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.request.addressExt }}</div>
        </b-col>
        <!-- TYPE DE VOIE -->
        <b-col lg="2" md="2" sm="12" cols="12">
          <label class="font-normal">Type de voie</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.request.addressType }}</div>
        </b-col>
        <!-- NOM VOIE -->
        <b-col lg="2" md="2" sm="12" cols="12" class="clearfix">
          <label class="font-normal">Nom de voie</label>
        </b-col>
        <b-col lg="4" md="4" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.request.addressName }}</div>
        </b-col>
        <!-- LIEU-DIT BOITE POSTALE -->
        <b-col lg="2" md="2" sm="12" cols="12">
          <label class="font-normal">Lieu-dit ou boite postale</label>
        </b-col>
        <b-col lg="4" md="4" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.request.place }}</div>
        </b-col>
        <!-- CODE POSTAL -->
        <b-col lg="2" md="2" sm="12" cols="12" class="clearfix">
          <label class="font-normal">Code Postal</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.request.addressPostalCode }}</div>
        </b-col>
        <!-- LOCALITE -->
        <b-col lg="2" md="2" sm="12" cols="12">
          <label class="font-normal">Localité</label>
        </b-col>
        <b-col lg="6" md="6" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.request.addressCity }}</div>
        </b-col>

        <b-col
          v-if="typeCerfa == '14023'"
          lg="12"
          md="12"
          sm="12"
          cols="12"
          class="no-padding"
        >
          <b-row>
            <b-col lg="12" md="12" sm="12" cols="12" class="marginTop">
              <label><b>Référence cadastrale :</b></label>
            </b-col>
            <b-col lg="4" md="4" sm="12" cols="12" class="clearfix">
              <label class="font-normal"
                >Document d'urbanisme antérieur (déclaration de travaux ou
                permis de construire) :</label
              >
            </b-col>
            <b-col lg="8" md="8" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.request.urbanDocument }}</div>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12" class="clearfix">
              <label>Section(s) :</label>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.request.sections }}</div>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Parcelle(s) :</label>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.request.plotNumbers }}</div>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Lieu-dit :</label>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.request.place }}</div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <!-- NATURE ET DATE DES TRAVAUX 14023 -->
    <div class="section" v-if="typeCerfa == '14023'">
      <h2>Nature des Travaux</h2>
      <b-row>
        <b-col lg="12" md="12" sm="12" cols="12">
          <div class="champ">
            <span
              :class="
                cerfaSelected.installationConnection == true
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal"
              >Pose de compteur / branchement aux réseaux</span
            >
          </div>
        </b-col>
        <b-col lg="12" md="12" sm="12" cols="12" class="marginTop">
          <table class="table-front">
            <tr>
              <th class="no-border"></th>
              <th>Pose de clôtures</th>
              <th>Pose de portail (portillon)</th>
              <th>Plantations</th>
            </tr>
            <tr>
              <td><label class="no-padding">A l'alignement</label></td>
              <td>
                <div class="champ">
                  <span
                    :class="
                      cerfaSelected.installationFencesAlignment == true
                        ? 'checkbox-checked'
                        : 'checkbox'
                    "
                    ><font-awesome-icon icon="check"></font-awesome-icon
                  ></span>
                  <span class="font-normal">Oui</span>
                  <span
                    :class="
                      cerfaSelected.installationFencesAlignment == false
                        ? 'checkbox-checked'
                        : 'checkbox'
                    "
                    ><font-awesome-icon icon="check"></font-awesome-icon
                  ></span>
                  <span class="font-normal">Non</span>
                </div>
              </td>
              <td>
                <div class="champ">
                  <span
                    :class="
                      cerfaSelected.installationGateAlignment == true
                        ? 'checkbox-checked'
                        : 'checkbox'
                    "
                    ><font-awesome-icon icon="check"></font-awesome-icon
                  ></span>
                  <span class="font-normal">Oui</span>
                  <span
                    :class="
                      cerfaSelected.installationGateAlignment == false
                        ? 'checkbox-checked'
                        : 'checkbox'
                    "
                    ><font-awesome-icon icon="check"></font-awesome-icon
                  ></span>
                  <span class="font-normal">Non</span>
                </div>
              </td>
              <td>
                <div class="champ">
                  <span
                    :class="
                      cerfaSelected.installationPlantationAlignment == true
                        ? 'checkbox-checked'
                        : 'checkbox'
                    "
                    ><font-awesome-icon icon="check"></font-awesome-icon
                  ></span>
                  <span class="font-normal">Oui</span>
                  <span
                    :class="
                      cerfaSelected.installationPlantationAlignment == false
                        ? 'checkbox-checked'
                        : 'checkbox'
                    "
                    ><font-awesome-icon icon="check"></font-awesome-icon
                  ></span>
                  <span class="font-normal">Non</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <label class="no-padding">En retrait de l'alignement</label>
              </td>
              <td>
                <b-row>
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="champ">
                      {{ cerfaSelected.installationFencesBackAlignment }}
                    </div>
                  </b-col>
                  <b-col lg="6" md="6" sm="12" cols="12" class="text-center">
                    <div class="font-normal">m</div>
                  </b-col>
                </b-row>
              </td>
              <td>
                <b-row>
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="champ">
                      {{ cerfaSelected.installationGateBackAlignment }}
                    </div>
                  </b-col>
                  <b-col lg="6" md="6" sm="12" cols="12" class="text-center">
                    <div class="font-normal">m</div>
                  </b-col>
                </b-row>
              </td>
              <td>
                <b-row>
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="champ">
                      {{ cerfaSelected.installationPlantationBackAlignment }}
                    </div>
                  </b-col>
                  <b-col lg="6" md="6" sm="12" cols="12" class="text-center">
                    <div class="font-normal">m</div>
                  </b-col>
                </b-row>
              </td>
            </tr>
            <tr>
              <td colspan="4" class="text-center">
                <div class="champ">
                  <span
                    :class="
                      cerfaSelected.themes != null &&
                      cerfaSelected.themes
                        .split(',')
                        .includes('depot_stationnement')
                        ? 'checkbox-checked'
                        : 'checkbox'
                    "
                    ><font-awesome-icon icon="check"></font-awesome-icon
                  ></span>
                  <span class="font-normal">Dépôt ou stationnement</span>
                  <span
                    :class="
                      cerfaSelected.themes != null &&
                      cerfaSelected.themes
                        .split(',')
                        .includes('saillie_surplomb')
                        ? 'checkbox-checked'
                        : 'checkbox'
                    "
                    ><font-awesome-icon icon="check"></font-awesome-icon
                  ></span>
                  <span class="font-normal">Saillie ou Surplomb</span>
                  <span
                    :class="
                      cerfaSelected.themes != null &&
                      cerfaSelected.themes
                        .split(',')
                        .includes('amenagement_acces')
                        ? 'checkbox-checked'
                        : 'checkbox'
                    "
                    ><font-awesome-icon icon="check"></font-awesome-icon
                  ></span>
                  <span class="font-normal">Aménagement d'accès</span>
                  <span
                    :class="
                      cerfaSelected.themes != null &&
                      cerfaSelected.themes
                        .split(',')
                        .includes('ouvrages_divers')
                        ? 'checkbox-checked'
                        : 'checkbox'
                    "
                    ><font-awesome-icon icon="check"></font-awesome-icon
                  ></span>
                  <span class="font-normal">Ouvrages divers</span>
                </div>
              </td>
            </tr>
          </table>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="marginTop">
          <div class="champ">
            <span
              :class="
                cerfaSelected.natureWork == 'station_service'
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Station service</span>
            <span
              :class="
                cerfaSelected.natureWork == 'renouvellement'
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Renouvellement</span>
            <span
              :class="
                cerfaSelected.natureWork == 'creation'
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Création</span>
            <span
              :class="
                cerfaSelected.natureWork != 'station_service' &&
                cerfaSelected.natureWork != 'creation' &&
                cerfaSelected.natureWork != 'renouvellement'
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Autres</span>
          </div>
        </b-col>
        <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Préciser</label>
            </b-col>
            <b-col lg="10" md="10" sm="12" cols="12">
              <div
                v-if="
                  cerfaSelected.natureWork != 'station_service' &&
                  cerfaSelected.natureWork != 'creation' &&
                  cerfaSelected.natureWork != 'renouvellement'
                "
                class="champ"
              >
                {{ cerfaSelected.natureWorkOther }}
              </div>
              <div v-else class="champ"></div>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="marginTop"></b-col>
        <!-- DATE -->
        <b-col lg="2" md="2" sm="12" cols="12" class="clearfix">
          <label class="font-normal">Date prévue de début d’application</label>
        </b-col>
        <b-col lg="4" md="4" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.request.dateStart }}</div>
        </b-col>
        <!-- LIEU-DIT BOITE POSTALE -->
        <b-col lg="2" md="2" sm="12" cols="12">
          <label class="font-normal"
            >Durée d'application (en jours calendaires)</label
          >
        </b-col>
        <b-col lg="4" md="4" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.request.numberDays }}</div>
        </b-col>
      </b-row>
    </div>

    <!-- NATURE ET DATE DES TRAVAUX 14024-->
    <div class="section" v-if="typeCerfa == '14024'">
      <h2>Nature des Travaux</h2>
      <b-row>
        <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Permission de voirie antérieure :</label>
            </b-col>
            <b-col lg="10" md="10" sm="12" cols="12">
              <div class="champ">
                <span
                  :class="
                    cerfaSelected.previousPermission == true
                      ? 'checkbox-checked'
                      : 'checkbox'
                  "
                  ><font-awesome-icon icon="check"></font-awesome-icon
                ></span>
                <span class="control-label font-normal">Oui</span>
                <span
                  :class="
                    cerfaSelected.previousPermission == false
                      ? 'checkbox-checked'
                      : 'checkbox'
                  "
                  ><font-awesome-icon icon="check"></font-awesome-icon
                ></span>
                <span class="control-label font-normal">Non</span>
              </div>
            </b-col>
            <b-col
              lg="12"
              md="12"
              sm="12"
              cols="12"
              class="no-padding marginTop"
              id="section-voirie-anterieur"
            >
              <b-row>
                <b-col lg="2" md="2" sm="12" cols="12">
                  <label>Si oui indiquer la référence</label>
                </b-col>
                <b-col lg="10" md="10" sm="12" cols="12">
                  <div class="champ">
                    {{ cerfaSelected.previousPermissionReference }}
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="12" md="12" sm="12" cols="12" class="no-padding marginTop">
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Description des travaux :</label>
            </b-col>
            <b-col lg="10" md="10" sm="12" cols="12">
              <div class="champ big">{{ cerfaSelected.workDescription }}</div>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="12" md="12" sm="12" cols="12" class="no-padding marginTop">
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Date prévue de début des travaux :</label>
            </b-col>
            <b-col lg="4" md="4" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.request.dateStart }}</div>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label
                >Durée des travaux <span>(en jours calendaires)</span>:</label
              >
            </b-col>
            <b-col lg="4" md="4" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.request.numberDays }}</div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <!--DEPOT OU STATIONNEMENT-->
    <div class="section" v-if="typeCerfa == '14023'">
      <h2>Dépôt ou stationnement</h2>
      <b-row>
        <b-col lg="2" md="2" sm="12" cols="12" class="no-padding">
          <label></label>
        </b-col>
        <b-col lg="10" md="10" sm="12" cols="12" class="no-padding">
          <div class="champ">
            <span
              :class="
                cerfaSelected.parkingExtension == false
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Demande initiale</span>
            <span
              :class="
                cerfaSelected.parkingExtension == true
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Prolongation</span>
          </div>
        </b-col>
        <b-col lg="12" md="12" sm="12" cols="12">
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12" class="no-padding">
              <label>Référence du permis de stationnement</label>
            </b-col>
            <b-col lg="10" md="10" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.parking_permit }}</div>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="2" md="2" sm="12" cols="12" class="marginTop">
          <label>Nature du dépôt ou stationnement</label>
        </b-col>
        <b-col lg="10" md="10" sm="12" cols="12" class="no-padding marginTop">
          <div class="champ">
            <span
              :class="
                cerfaSelected.parkingNature != null &&
                cerfaSelected.parkingNature.split(',').includes('Matériaux')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Matériaux</span>
            <span
              :class="
                cerfaSelected.parkingNature != null &&
                cerfaSelected.parkingNature.split(',').includes('Benne')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Benne</span>
            <span
              :class="
                cerfaSelected.parkingNature != null &&
                cerfaSelected.parkingNature.split(',').includes('Grue')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Grue</span>
            <span
              :class="
                cerfaSelected.parkingNature != null &&
                cerfaSelected.parkingNature.split(',').includes('Etalage')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Etalage</span>
            <span
              :class="
                cerfaSelected.parkingNature != null &&
                cerfaSelected.parkingNature.split(',').includes('Echafaudage')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Echafaudage</span>
            <span
              :class="
                cerfaSelected.parkingNature != null &&
                cerfaSelected.parkingNature
                  .split(',')
                  .includes('Mobilier urbain')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Mobilier Urbain</span>
            <span
              :class="
                cerfaSelected.parkingNature != null &&
                cerfaSelected.parkingNature.split(',').includes('terasse_cafe')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Terasses de café</span>
            <span
              :class="
                cerfaSelected.parkingNature != null &&
                cerfaSelected.parkingNature
                  .split(',')
                  .includes('Vente le long de la voie ou aire de service')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal"
              >Vente le long de la voie ou sur aire de service</span
            >
            <span
              :class="
                cerfaSelected.parkingNatureOther != null &&
                cerfaSelected.parkingNatureOther != ''
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Autres</span>
          </div>
        </b-col>
        <b-col lg="12" md="12" sm="12" cols="12">
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12" class="no-padding">
              <label>Préciser</label>
            </b-col>
            <b-col lg="10" md="10" sm="12" cols="12">
              <div class="champ">
                <span>
                  {{ cerfaSelected.parkingNatureOther }}
                </span>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <!--REGLEMENTATION SOUHAITEE-->
    <div class="section" v-if="typeCerfa == '14024'">
      <h2>Réglementation souhaitée</h2>
      <b-row>
        <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label
                >Durée de la réglementation
                <span>(en jours calendaires)</span>:</label
              >
            </b-col>
            <b-col lg="4" md="4" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.durationRegulation }}</div>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Date de début de réglementation :</label>
            </b-col>
            <b-col lg="4" md="4" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.dateRegulation }}</div>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="no-padding marginTop">
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label></label>
            </b-col>
            <b-col lg="10" md="10" sm="12" cols="12">
              <div class="champ">
                <span
                  :class="
                    cerfaSelected.restrictionSuspenders === false
                      ? 'checkbox-checked'
                      : 'checkbox'
                  "
                  ><font-awesome-icon icon="check"></font-awesome-icon
                ></span>
                <span class="control-label font-normal"
                  >Restriction sur section courante</span
                >
                <span
                  :class="
                    cerfaSelected.restrictionSuspenders === true
                      ? 'checkbox-checked'
                      : 'checkbox'
                  "
                  ><font-awesome-icon icon="check"></font-awesome-icon
                ></span>
                <span class="control-label font-normal"
                  >Restriction sur bretelles</span
                >
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="no-padding marginTop">
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Sens de circulation concerné</label>
            </b-col>
            <b-col lg="10" md="10" sm="12" cols="12">
              <div class="champ">
                <span
                  :class="
                    cerfaSelected.directionTraffic == 'Deux sens de circulation'
                      ? 'checkbox-checked'
                      : 'checkbox'
                  "
                  ><font-awesome-icon icon="check"></font-awesome-icon
                ></span>
                <span class="control-label font-normal"
                  >Deux sens de circulation</span
                >
                <span
                  :class="
                    cerfaSelected.directionTraffic ==
                    'Sens des points de Repères (PR) croissants'
                      ? 'checkbox-checked'
                      : 'checkbox'
                  "
                  ><font-awesome-icon icon="check"></font-awesome-icon
                ></span>
                <span class="control-label font-normal"
                  >Sens des points de Repères (PR) croissants</span
                >
                <span
                  :class="
                    cerfaSelected.directionTraffic ==
                    'Sens des points de Repères (PR) décroissants'
                      ? 'checkbox-checked'
                      : 'checkbox'
                  "
                  ><font-awesome-icon icon="check"></font-awesome-icon
                ></span>
                <span class="control-label font-normal"
                  >Sens des points de Repères (PR) décroissants</span
                >
                <span
                  :class="
                    cerfaSelected.directionTraffic ==
                    'Fermeture à la circulation'
                      ? 'checkbox-checked'
                      : 'checkbox'
                  "
                  ><font-awesome-icon icon="check"></font-awesome-icon
                ></span>
                <span class="control-label font-normal"
                  >Fermeture à la circulation</span
                >
                <span
                  :class="
                    cerfaSelected.directionTraffic ==
                    'Basculement de circulation sur chaussée opposée'
                      ? 'checkbox-checked'
                      : 'checkbox'
                  "
                  ><font-awesome-icon icon="check"></font-awesome-icon
                ></span>
                <span class="control-label font-normal"
                  >Basculement de circulation sur chaussée opposée</span
                >
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="no-padding marginTop">
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Circulation alternée</label>
            </b-col>
            <b-col lg="10" md="10" sm="12" cols="12">
              <div class="champ">
                <span
                  :class="
                    cerfaSelected.alternatingCirculationManual === false
                      ? 'checkbox-checked'
                      : 'checkbox'
                  "
                  ><font-awesome-icon icon="check"></font-awesome-icon
                ></span>
                <span class="control-label font-normal"
                  >Par feux tricolores</span
                >
                <span
                  :class="
                    cerfaSelected.alternatingCirculationManual === true
                      ? 'checkbox-checked'
                      : 'checkbox'
                  "
                  ><font-awesome-icon icon="check"></font-awesome-icon
                ></span>
                <span class="control-label font-normal">Manuellement</span>
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="no-padding marginTop">
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Restriction de chaussée</label>
            </b-col>
            <b-col lg="10" md="10" sm="12" cols="12">
              <div class="champ">
                <span
                  :class="
                    cerfaSelected.emergencyRestriction == true
                      ? 'checkbox-checked'
                      : 'checkbox'
                  "
                  ><font-awesome-icon icon="check"></font-awesome-icon
                ></span>
                <span class="control-label font-normal"
                  >Neutralisation de la bande d'arrêt d'urgence (BAU)</span
                >

                <span
                  :class="
                    cerfaSelected.encroachmentRoadway == true
                      ? 'checkbox-checked'
                      : 'checkbox'
                  "
                  ><font-awesome-icon icon="check"></font-awesome-icon
                ></span>
                <span class="control-label font-normal"
                  >Empiètement sur chaussée</span
                >
                <span
                  :class="
                    cerfaSelected.numberWayRemoved == true
                      ? 'checkbox-checked'
                      : 'checkbox'
                  "
                  ><font-awesome-icon icon="check"></font-awesome-icon
                ></span>
                <span class="control-label font-normal"
                  >Suppression de voie</span
                >
              </div>
            </b-col>

            <b-col
              lg="12"
              md="12"
              sm="12"
              cols="12"
              class="no-padding marginTop"
              id="section-empietement"
            >
              <b-row>
                <b-col lg="2" md="2" sm="12" cols="12">
                  <label>Largeur de voie maintenue</label>
                </b-col>
                <b-col lg="10" md="10" sm="12" cols="12">
                  <div class="champ">
                    {{ cerfaSelected.trackWidthMaintained }}
                  </div>
                </b-col>
              </b-row>
            </b-col>

            <b-col
              lg="12"
              md="12"
              sm="12"
              cols="12"
              class="no-padding marginTop"
              id="section-suppression"
            >
              <b-row>
                <b-col lg="2" md="2" sm="12" cols="12">
                  <label>Nombre de voie(s) supprimée(s)</label>
                </b-col>
                <b-col lg="10" md="10" sm="12" cols="12">
                  <div class="champ">{{ cerfaSelected.numberWayRemoved }}</div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="no-padding marginTop">
          <b-row>
            <b-col lg="4" md="4" sm="12" cols="12">
              <b-row>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="no-padding text-center"
                >
                  <b>Circuler</b>
                </b-col>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="no-padding text-center"
                >
                  <div class="champ">
                    <span
                      :class="
                        cerfaSelected.moveCar == true
                          ? 'checkbox-checked'
                          : 'checked'
                      "
                      ><font-awesome-icon icon="check"></font-awesome-icon
                    ></span>
                    <span class="control-label font-normal"
                      >Véhicules légers</span
                    >
                    <span
                      :class="
                        cerfaSelected.moveTruck == true
                          ? 'checkbox-checked'
                          : 'checked'
                      "
                      ><font-awesome-icon icon="check"></font-awesome-icon
                    ></span>
                    <span class="control-label font-normal">Poids lourds</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="4" md="4" sm="12" cols="12">
              <b-row>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="no-padding text-center"
                >
                  <b>Stationner</b>
                </b-col>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="no-padding text-center"
                >
                  <div class="champ">
                    <span
                      :class="
                        cerfaSelected.parkCar == true
                          ? 'checkbox-checked'
                          : 'checked'
                      "
                      ><font-awesome-icon icon="check"></font-awesome-icon
                    ></span>
                    <span class="control-label font-normal"
                      >Véhicules légers</span
                    >
                    <span
                      :class="
                        cerfaSelected.parkTruck == true
                          ? 'checkbox-checked'
                          : 'checked'
                      "
                      ><font-awesome-icon icon="check"></font-awesome-icon
                    ></span>
                    <span class="control-label font-normal">Poids lourds</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="4" md="4" sm="12" cols="12">
              <b-row>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="no-padding text-center"
                >
                  <b>Dépasser</b>
                </b-col>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="no-padding text-center"
                >
                  <div class="champ">
                    <span
                      :class="
                        cerfaSelected.overtakeCar == true
                          ? 'checkbox-checked'
                          : 'checked'
                      "
                      ><font-awesome-icon icon="check"></font-awesome-icon
                    ></span>
                    <span class="control-label font-normal"
                      >Véhicules légers</span
                    >
                    <span
                      :class="
                        cerfaSelected.overtakeTruck == true
                          ? 'checkbox-checked'
                          : 'checked'
                      "
                      ><font-awesome-icon icon="check"></font-awesome-icon
                    ></span>
                    <span class="control-label font-normal">Poids lourds</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="no-padding marginTop">
          <b-row>
            <b-col
              lg="12"
              md="12"
              sm="12"
              cols="12"
              class="clearfix marginBigTop"
            ></b-col>

            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Vitesse limitée à :</label>
            </b-col>
            <b-col lg="4" md="4" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.limitedSpeed }}</div>
            </b-col>
            <b-col lg="1" md="1" sm="12" cols="12" class="text-left">
              <div class="font-normal">km/h</div>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="no-padding marginTop">
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label
                >Itinéraire de déviation
                <span>(à préciser par sens)</span> :</label
              >
            </b-col>
            <b-col lg="10" md="10" sm="12" cols="12">
              <div class="champ big">{{ cerfaSelected.detourRoute }}</div>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="no-padding marginTop">
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Autres prescriptions :</label>
            </b-col>
            <b-col lg="10" md="10" sm="12" cols="12">
              <div class="champ big">
                {{ cerfaSelected.otherPrescriptions }}
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <!-- SAILLIE OU SURPLOMB -->
    <div class="section" v-if="typeCerfa == '14023'">
      <h2>Saillie ou surplomb</h2>
      <b-row>
        <b-col lg="2" md="2" sm="12" cols="12">
          <label>Largeur :</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <label>de la voie :</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.trackWidth }}</div>
        </b-col>
        <b-col lg="1" md="1" sm="12" cols="12" class="text-left">
          <div class="font-normal">m</div>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <label>de la saillie :</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.protrusionWidth }}</div>
        </b-col>
        <b-col lg="1" md="1" sm="12" cols="12" class="text-left">
          <div class="font-normal">m</div>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="clearfix"></b-col>

        <b-col lg="2" md="2" sm="12" cols="12"></b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <label>des trottoirs :</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.sidewalkWidth }}</div>
        </b-col>
        <b-col lg="1" md="1" sm="12" cols="12" class="text-left">
          <div class="font-normal">m</div>
        </b-col>

        <b-col lg="2" md="2" sm="12" cols="12">
          <label>hauteurs sous saillie :</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.heightUnderProtrusion }}</div>
        </b-col>
        <b-col lg="1" md="1" sm="12" cols="12" class="text-left">
          <div class="font-normal">m</div>
        </b-col>
      </b-row>
    </div>

    <!-- LA POSE -->
    <div class="section" v-if="typeCerfa == '14024'">
      <h2>
        La pose, le maintien ou le retreait de la signalisation spécifique au
        chantier sont effectués par :
      </h2>
      <b-row>
        <b-col lg="12" md="12" sm="12" cols="12">
          <div class="champ">
            <span
              :class="
                cerfaSelected.gestSignageTitle == 'Le demandeur'
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="control-label font-normal">Le demandeur</span>
            <span
              :class="
                cerfaSelected.gestSignageTitle == 'Une entreprise spécialisée'
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="control-label font-normal"
              >Une entreprise spécialité</span
            >
          </div>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="marginTop"></b-col>
        <!-- NOM -->
        <b-col lg="2" md="2" sm="12" cols="12" class="clearfix">
          <label class="font-normal">Nom</label>
        </b-col>
        <b-col lg="4" md="4" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.gestSignageLastName }}</div>
        </b-col>
        <!-- PRENOM -->
        <b-col lg="2" md="2" sm="12" cols="12">
          <label class="font-normal">Prénom</label>
        </b-col>
        <b-col lg="4" md="4" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.gestSignageFirstName }}</div>
        </b-col>

        <!-- DESIGNATION -->
        <b-col lg="2" md="2" sm="12" cols="12" class="clearfix">
          <label class="font-normal clearfix">Dénomination</label>
        </b-col>
        <b-col lg="4" md="4" sm="12" cols="12">
          <div class="champ">
            {{ cerfaSelected.gestSignageCorporationName }}
          </div>
        </b-col>
        <!-- SIRET -->
        <b-col lg="2" md="2" sm="12" cols="12">
          <label class="font-normal">N° SIRET</label>
        </b-col>
        <b-col lg="4" md="4" sm="12" cols="12">
          <div class="champ">
            {{ cerfaSelected.gestSignageCorporationSiret }}
          </div>
        </b-col>

        <!-- NOM, PRENOM -->
        <b-col lg="2" md="2" sm="12" cols="12" class="clearfix">
          <label class="font-normal">Représenté par</label>
        </b-col>
        <b-col lg="10" md="10" sm="12" cols="12">
          <div class="champ">
            {{ cerfaSelected.gestSignageCorporationAgent }}
          </div>
        </b-col>

        <!--ADRESSE SIEGE SOCIALE-->
        <b-col lg="12" md="12" sm="12" cols="12" class="clearfix">
          <label>Adresse</label>
        </b-col>
        <!-- N° VOIE -->
        <b-col lg="2" md="2" sm="12" cols="12" class="clearfix">
          <label class="font-normal">N° voie</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.gestSignageAddressNum }}</div>
        </b-col>
        <!-- EXTENSION -->
        <b-col lg="2" md="2" sm="12" cols="12">
          <label class="font-normal">Extension</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.gestSignageAddressExt }}</div>
        </b-col>
        <!-- TYPE DE VOIE -->
        <b-col lg="2" md="2" sm="12" cols="12">
          <label class="font-normal">Type de voie</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.gestSignageAddressType }}</div>
        </b-col>
        <!-- NOM VOIE -->
        <b-col lg="2" md="2" sm="12" cols="12" class="clearfix">
          <label class="font-normal">Nom de voie</label>
        </b-col>
        <b-col lg="10" md="10" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.gestSignageAddressName }}</div>
        </b-col>
        <!-- CODE POSTAL -->
        <b-col lg="2" md="2" sm="12" cols="12" class="clearfix">
          <label class="font-normal">Code Postal</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">
            {{ cerfaSelected.gestSignageAddressPostalCode }}
          </div>
        </b-col>
        <!-- LOCALITE -->
        <b-col lg="2" md="2" sm="12" cols="12">
          <label class="font-normal">Localité</label>
        </b-col>
        <b-col lg="6" md="6" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.gestSignageAddressCity }}</div>
        </b-col>

        <!-- TELEPHONE -->
        <b-col cols="12" sm="12" md="3" lg="2">
          <label class="font-normal clearfix">Téléphone</label>
        </b-col>
        <b-col cols="12" sm="12" md="3" lg="4">
          <div class="champ">{{ cerfaSelected.gestSignagePhone }}</div>
        </b-col>

        <!-- INDICATIF
        <b-col cols="12" sm="12" md="3" lg="2">
          <label class=" font-normal clearfix "
            >indiquez l’indicatif pour le pays étranger</label
          >
        </b-col>
        <b-col cols="12" sm="12" md="3" lg="4">
          <div class="champ">
            {{ cerfaSelected.gestSignagePhoneIndicative }}
          </div>
        </b-col> -->

        <b-col cols="12" sm="12" md="12" lg="12" class="nopadding"></b-col>

        <!-- EMAIL -->
        <b-col cols="12" sm="12" md="3" lg="2">
          <label class="font-normal clearfix">Adresse email</label>
        </b-col>
        <b-col cols="12" sm="12" md="9" lg="10">
          <div class="champ">{{ cerfaSelected.gestSignageEmail }}</div>
        </b-col>
      </b-row>
    </div>

    <!-- AMENAGEMENT D'ACCES -->
    <div class="section" v-if="typeCerfa == '14023'">
      <h2>Aménagement d'accès</h2>
      <b-row>
        <b-col lg="2" md="2" sm="12" cols="12" class="no-padding">
          <label></label>
        </b-col>
        <b-col lg="10" md="10" sm="12" cols="12" class="no-padding">
          <div class="champ">
            <span
              :class="
                cerfaSelected.ditchCrossing == true
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Avec franchissement de fossé</span>
          </div>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="clearfix"></b-col>

        <b-col lg="2" md="2" sm="12" cols="12">
          <label></label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <label>Diamètre du tuyau :</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.pipeDiameter }}</div>
        </b-col>
        <b-col lg="1" md="1" sm="12" cols="12" class="text-left">
          <div class="font-normal">m</div>
        </b-col>

        <b-col lg="2" md="2" sm="12" cols="12">
          <label>Longueur :</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.pipeLength }}</div>
        </b-col>
        <b-col lg="1" md="1" sm="12" cols="12" class="text-left">
          <div class="font-normal">m</div>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label></label>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Distance par rapport à l'axe de la chaussée :</label>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.distanceFromRoad }}</div>
            </b-col>
            <b-col lg="1" md="1" sm="12" cols="12" class="text-left">
              <div class="font-normal">m</div>
            </b-col>

            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Nature du tuyau :</label>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.typePipe }}</div>
            </b-col>
            <b-col lg="1" md="1" sm="12" cols="12" class="text-left">
              <div class="font-normal"></div>
            </b-col>
          </b-row>
        </b-col>

        <b-col
          lg="2"
          md="2"
          sm="12"
          cols="12"
          class="clearfix no-padding marginTop"
        >
          <label></label>
        </b-col>
        <b-col lg="10" md="10" sm="12" cols="12" class="no-padding marginTop">
          <div class="champ">
            <span
              :class="
                cerfaSelected.ditchCrossing == false
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Sans franchissement de fossé</span>
          </div>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="clearfix"></b-col>

        <b-col lg="2" md="2" sm="12" cols="12">
          <label></label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <label>Largueur de l'aménagement :</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <div class="champ">{{ cerfaSelected.layoutWidth }}</div>
        </b-col>
        <b-col lg="1" md="1" sm="12" cols="12" class="text-left">
          <div class="font-normal">m</div>
        </b-col>
      </b-row>
    </div>

    <!-- OUVRAGES DIVERS -->
    <div class="section" v-if="typeCerfa == '14023'">
      <h2>Ouvrages divers</h2>
      <b-row>
        <b-col lg="2" md="2" sm="12" cols="12" class="no-padding">
          <label></label>
        </b-col>
        <b-col lg="10" md="10" sm="12" cols="12" class="no-padding">
          <div class="champ">
            <span
              :class="
                cerfaSelected.newInstallation != null &&
                cerfaSelected.newInstallation
                  .split(',')
                  .includes('false')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Travaux sur ouvrages existants</span>
            <span
              :class="
                cerfaSelected.newInstallation != null &&
                  cerfaSelected.newInstallation
                    .split(',')
                    .includes('true')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Installation nouvelle</span>
          </div>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="marginTop">
          <label>Réseaux aériens ou souterrains ou branchement</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12" class="no-padding clearfix">
          <label></label>
        </b-col>
        <b-col lg="10" md="10" sm="12" cols="12" class="no-padding">
          <div class="champ">
            <span
              :class="
                cerfaSelected.networkConnection != null &&
                cerfaSelected.networkConnection
                  .split(',')
                  .includes('eau_potable')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Eau potable</span>
            <span
              :class="
                cerfaSelected.networkConnection != null &&
                cerfaSelected.networkConnection
                  .split(',')
                  .includes('eaux_pluviales')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Eaux pluviales</span>
            <span
              :class="
                cerfaSelected.networkConnection != null &&
                cerfaSelected.networkConnection.split(',').includes('gdf')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">GDF</span>
            <span
              :class="
                cerfaSelected.networkConnection != null &&
                cerfaSelected.networkConnection
                  .split(',')
                  .includes('operateurs_reseaux')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Opérateurs réseaux</span>
            <span
              :class="
                cerfaSelected.networkConnection != null &&
                cerfaSelected.networkConnection
                  .split(',')
                  .includes('eaux_usees')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Eaux usées</span>
            <span
              :class="
                cerfaSelected.networkConnection != null &&
                cerfaSelected.networkConnection.split(',').includes('edf')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">EDF</span>
            <span
              :class="
                cerfaSelected.networkConnectionOther != null &&
                cerfaSelected.networkConnectionOther != ''
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Autres</span>
          </div>
        </b-col>

        <b-col
          lg="12"
          md="12"
          sm="12"
          cols="12"
          class="no-padding"
          id="section_branchement"
        >
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Préciser</label>
            </b-col>
            <b-col lg="10" md="10" sm="12" cols="12">
              <div class="champ">
                <span>{{ cerfaSelected.networkConnectionOther }}</span>
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="marginTop">
          <table class="table-front marginTop">
            <tr>
              <th class="no-border"></th>
              <th>Sous voirie</th>
              <th>Sous accotement ou trottoirs</th>
            </tr>
            <tr>
              <td><label class="no-padding">Tranchée longitudinale</label></td>
              <td>
                <b-row>
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="champ">
                      {{ cerfaSelected.longitudinalTrenchUnderRoad }}
                    </div>
                  </b-col>
                  <b-col lg="6" md="6" sm="12" cols="12" class="text-center">
                    <div class="font-normal">m</div>
                  </b-col>
                </b-row>
              </td>
              <td>
                <b-row>
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="champ">
                      {{ cerfaSelected.longitudinalTrenchUnderSidewalks }}
                    </div>
                  </b-col>
                  <b-col lg="6" md="6" sm="12" cols="12" class="text-center">
                    <div class="font-normal">m</div>
                  </b-col>
                </b-row>
              </td>
            </tr>
            <tr>
              <td><label class="no-padding">Tranchée transversale</label></td>
              <td>
                <b-row>
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="champ">
                      {{ cerfaSelected.transverseTrenchUnderRoad }}
                    </div>
                  </b-col>
                  <b-col lg="6" md="6" sm="12" cols="12" class="text-center">
                    <div class="font-normal">m</div>
                  </b-col>
                </b-row>
              </td>
              <td>
                <b-row>
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="champ">
                      {{ cerfaSelected.transverseTrenchUnderSidewalks }}
                    </div>
                  </b-col>
                  <b-col lg="6" md="6" sm="12" cols="12" class="text-center">
                    <div class="font-normal">m</div>
                  </b-col>
                </b-row>
              </td>
            </tr>
            <tr>
              <td><label class="no-padding">Fonçage</label></td>
              <td>
                <b-row>
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="champ">
                      {{ cerfaSelected.drivingUnderRoad }}
                    </div>
                  </b-col>
                  <b-col lg="6" md="6" sm="12" cols="12" class="text-center">
                    <div class="font-normal">m</div>
                  </b-col>
                </b-row>
              </td>
              <td>
                <b-row>
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="champ">
                      {{ cerfaSelected.drivingUnderSidewalks }}
                    </div>
                  </b-col>
                  <b-col lg="6" md="6" sm="12" cols="12" class="text-center">
                    <div class="font-normal">m</div>
                  </b-col>
                </b-row>
              </td>
            </tr>
          </table>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="marginTop">
          <label>Aménagement de surface ou équipements</label>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12">
          <label></label>
        </b-col>
        <b-col lg="10" md="10" sm="12" cols="12">
          <div class="champ">
            <span
              :class="
                cerfaSelected.surfacePlanningEquipment != null &&
                cerfaSelected.surfacePlanningEquipment
                  .split(',')
                  .includes('stationnement')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Stationnement</span>
            <span
              :class="
                cerfaSelected.surfacePlanningEquipment != null &&
                cerfaSelected.surfacePlanningEquipment
                  .split(',')
                  .includes('arret_bus')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Arrêt bus</span>
            <span
              :class="
                cerfaSelected.surfacePlanningEquipment != null &&
                cerfaSelected.surfacePlanningEquipment
                  .split(',')
                  .includes('passage_sup_inf')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Passage supérieur ou inférieur</span>
            <span
              :class="
                cerfaSelected.surfacePlanningEquipment != null &&
                cerfaSelected.surfacePlanningEquipment
                  .split(',')
                  .includes('equipement_route')
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Equipements de la route</span>
            <span
              :class="
                cerfaSelected.surfacePlanningEquipmentOther != null &&
                cerfaSelected.surfacePlanningEquipmentOther != ''
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="font-normal">Autres</span>
          </div>
        </b-col>

        <b-col
          lg="12"
          md="12"
          sm="12"
          cols="12"
          id="section_amenagement"
          class="no-padding"
        >
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label>Préciser</label>
            </b-col>
            <b-col lg="10" md="10" sm="12" cols="12">
              <div class="champ">
                {{ cerfaSelected.surfacePlanningEquipmentOther }}
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <!-- J'ATTESTE -->
    <div class="section">
      <h2>Attestation</h2>
      <b-row>
        <b-col lg="12" md="12" sm="12" cols="12">
          <div class="champ">
            <span
              :class="
                cerfaSelected.request.accuracyInformation
                  ? 'checkbox-checked'
                  : 'checkbox'
              "
              ><font-awesome-icon icon="check"></font-awesome-icon
            ></span>
            <span class="control-label font-normal"
              >J'atteste de l'exactitude des informations fournies</span
            >
          </div>
        </b-col>
        <!-- A -->
        <b-col
          lg="12"
          md="12"
          sm="12"
          cols="12"
          class="clearfix marginTop no-padding"
        >
          <b-row>
            <b-col lg="2" md="2" sm="12" cols="12">
              <label class="font-normal">Fait à :</label>
            </b-col>
            <b-col lg="6" md="6" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.request.madeIn }}</div>
            </b-col>
            <!-- LE -->
            <b-col lg="2" md="2" sm="12" cols="12">
              <div class="font-normal">Le</div>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.request.madeDate }}</div>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="12" md="12" sm="12" cols="12" class="clearfix no-padding">
          <b-row>
            <!-- Nom -->
            <b-col lg="2" md="2" sm="12" cols="12" class="clearfix">
              <label class="font-normal">Nom</label>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.request.madeFirstName }}</div>
            </b-col>
            <!-- Prénom -->
            <b-col lg="2" md="2" sm="12" cols="12">
              <div class="font-normal">Prénom</div>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.request.madeLastName }}</div>
            </b-col>
            <!-- Qualité -->
            <b-col lg="2" md="2" sm="12" cols="12">
              <div class="font-normal">Qualité</div>
            </b-col>
            <b-col lg="2" md="2" sm="12" cols="12">
              <div class="champ">{{ cerfaSelected.request.madeFonction }}</div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <b-row>
      <b-col
        lg="12"
        md="12"
        sm="12"
        cols="12"
        class="marginTop clearfix"
      ></b-col>
    </b-row>
  </div>
</template>
<script>
import router from "../router/index.js";
import Vuex from "vuex";
export default {
  name: "Cerfa",
  data: () => ({
    typeCerfa: "",
    idCerfa: "",
  }),
  props: ["type", "id"],
  mounted() {
    if (this.$route.params.type && this.$route.params.id) {
      this.typeCerfa = this.$route.params.type;
      let decrypted = this.$aes.decrypt(this.$route.params.id);
      this.idCerfa = decrypted;
    } else {
      this.typeCerfa = this.type;
      this.idCerfa = this.id;
    }

    let payload = {
      type: this.typeCerfa,
      id: this.idCerfa,
    };
    this.getCerfa(payload);
  },
  methods: {
    ...Vuex.mapActions("Cerfa", ["getCerfa"]),
  },
  computed: {
    ...Vuex.mapGetters("Cerfa", ["cerfaSelected"]),
  },
};
</script>
